/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import React, { Fragment, useState } from 'react'
import { message } from 'antd'
import { find } from 'lodash'
import { Modal } from 'antd-mobile'
import { observer } from 'mobx-react'
import { isMobile } from 'react-device-detect'

import useRootStore from '@store/useRootStore'
import { ModalBg, Point } from '@styles/base.style'
import { BottomBtnStyle, Button, ButtonWrap, CloseBtn, PopupBtnStyle } from '@styles/button.style'
import { formatNumber, getPickPublishMoney, getTicketCountFromTicket, loadOrReload } from '@utils/utils'
// icon
import { GmoneyIco } from '@shared/Icon/MoneyIcon'
import { CheckIco } from '@shared/Icon/EtcIcon'
// css
import { Theme } from '@themes/theme'
import Pick from '@views/Pick'
import { BET_TICKET_TYPE, GENERAL_POPUP_ID, PUBLISH_PICK_TYPE } from '@constants/index'
import { Num, PickPopupRowStyle, PopupTxt } from './index.style'

const Gmoeny = <GmoneyIco/>

export const PointStyle = (theme: Theme) => css`
  display: inline-block;
  margin: 10px 0 14px;
  line-height: 1.6rem;
  text-align: center;
  letter-spacing: -1px;
  color: ${theme.color.modalred};
`

const PickPurchase: React.FC = () => {
  const [visibleChild, setVisibleChild] = useState(false)
  const [visibleUseBetDialog, setVisibleUseBetDialog] = useState(false)
  // const [isSpecificClubPick, setSpecificClubPick] = useState(false)
  // const [pickClubId, setPickClubId] = useState('')

  const { authStore, pickStore, messageStore, globalStore } = useRootStore()
  const { userInfo, isSpecificClubMember } = authStore
  const { purchasePick, fetchPickList } = pickStore
  const { messageList } = messageStore
  const visible = !!purchasePick
  let publishMoneyType = PUBLISH_PICK_TYPE.HEART

  let price
  let remain
  if (userInfo && purchasePick) {
    price = getPickPublishMoney(purchasePick.publishMoneyType, purchasePick.priceMoney)
    const typeMoney = purchasePick.publishMoneyType === PUBLISH_PICK_TYPE.HEART ?
      userInfo.money :
      getTicketCountFromTicket(BET_TICKET_TYPE.BET_TICKET1, userInfo.ticket)

    remain = typeMoney - price

    publishMoneyType = purchasePick.publishMoneyType
  }

  // useEffect(() => {
  //   if (purchasePick) {
  //     setPickClubId(purchasePick.clubId)
  //     setSpecificClubPick(purchasePick.isSpecificClub)
  //   }
  //
  //   setTimeout(() => {
  //     if (!purchasePick) {
  //       setPickClubId('')
  //       setSpecificClubPick(false)
  //     }
  //   }, 60 * 1000)
  // }, [purchasePick])
  //
  // useOnUnmount(() => {
  //   setPickClubId('')
  //   setSpecificClubPick(false)
  // })

  const buyPickProgress = async (isPickBuy = false) => {
    let track = null
    if (messageList && messageList.tracks) {
      track = find(messageList.tracks, { content: `{"pickId":"${purchasePick.pickId}"}` })
      if (track) {
        track.receiverRead = 1
        track.pickPurchase = {}
      }
    }
    const ret = await pickStore.buyPick(isPickBuy)
    if (ret === true) {
      if (fetchPickList) {
        fetchPickList()
      }
      if (track) {
        document.getElementById(`${track.id}`).classList.add('received')
        document.getElementById(`${track.id}`).classList.add('read')
        await messageStore.readMessage({ messageId: track.id })
      }
      setVisibleChild(true)
    } else {
      pickStore.setPurchasePick(null)
    }
  }


  const onClickBuy = async () => {
    if (remain >= 0) {
      setVisibleUseBetDialog(true)
      // 더 이상 사용하지 않는 다이얼로그
      globalStore.pushDialogYesNo({
        title: '알림',
        text: ['픽을 구매하시겠습니까?'],
        className: 'small-size',
        negativePress: '취소',
        positivePress: '구매',
        callbackNegative: async () => {
          setVisibleUseBetDialog(false)
        },
        callbackPositive: async () => {
          const isBuyTicket = publishMoneyType === PUBLISH_PICK_TYPE.TICKET
          await buyPickProgress(isBuyTicket)
          setVisibleUseBetDialog(false)
        },
      })
    } else {
      const msg = publishMoneyType === PUBLISH_PICK_TYPE.HEART ?
        'G머니가 부족합니다.' :
        '베팅권이 부족합니다.'
      message.info(msg)
    }
  }

  // const gMoneyBuyProcess = async () => {
  //   if (remain < 0) {
  //     message.info('G머니가 부족합니다')
  //   } else {
  //     await buyPickProgress(false)
  //   }
  // }
  //
  // const onClickBuy = async () => {
  //   if (availableTicketBuy && userInfo.ticket >= price) {
  //     setVisibleUseBetDialog(true)
  //     globalStore.pushDialogYesNo({
  //       title: '알림',
  //       text: ['베팅권으로 픽을 구매할 수 있습니다.', '픽을 구매하시겠습니까?', '(취소시 G머니로 구매합니다.)'],
  //       negativePress: '취소',
  //       positivePress: '구매',
  //       callbackNegative: async () => {
  //         await gMoneyBuyProcess()
  //         setVisibleUseBetDialog(false)
  //       },
  //       callbackPositive: async () => {
  //         await buyPickProgress(true)
  //         setVisibleUseBetDialog(false)
  //       },
  //     })
  //   } else {
  //     gMoneyBuyProcess()
  //   }
  // }

  const onClickPickPurchasePopupCloseButton = () => pickStore.setPurchasePick(null)
  const onClickPickBuyDonePopupCloseButton = () => setVisibleChild(false)
  const onClickPickBuyDonePopupCancelButton = () => {
    pickStore.setPurchasePick(null)
    setVisibleChild(false)
  }
  const onClickPickBuyNextStepButton = () => {
    pickStore.setPurchasePick(null)
    pickStore.setTab(2)
    setVisibleChild(false)
    globalStore.setVisibleQuickMessagePopup(false)
    globalStore.closeGeneralPopup()

    if (isMobile) {
      loadOrReload('/pick')
    } else if (globalStore.currentGeneralPopup?.popupId !== GENERAL_POPUP_ID.PICK) {
      globalStore.addGeneralPopupProperties(<Pick/>, '픽거래소', { wrapClassName: '', className: '', isScroll: false, custom: false, clsBtn: false }, 'pick', GENERAL_POPUP_ID.PICK)
    }
  }

  const isBettingAvailable = () => {
    return !isSpecificClubMember
  }

  return (
    <Fragment>
      <Modal
        popup
        visible={visible && !visibleChild && !visibleUseBetDialog}
        maskClosable={false}
        className="short-top pick-purchase pc-close-btn-modal"
        animated={isMobile}
        animationType="slide-up"
        onClose={onClickPickPurchasePopupCloseButton}
        title="해당 픽을 구매하시겠습니까?"
      >
        <Button
          circle
          onClick={onClickPickPurchasePopupCloseButton}
          css={CloseBtn}
          className="close-btn modal-circle-close-btn">
          <span className="close-txt">닫기</span>
        </Button>

        <div css={PickPopupRowStyle}>
          <span className="pick-popup-price-txt">픽가격</span>
          <span className="pick-popup-price-num">
            <Num className="pick-popup">{formatNumber(price)}</Num>
            <span className="pick-popup-price-num--type">
              {publishMoneyType === PUBLISH_PICK_TYPE.HEART ?
                Gmoeny :
                '개'}
            </span>
          </span>
        </div>

        <div css={PickPopupRowStyle}>
          <span className="pick-popup-price-txt">
            {publishMoneyType === PUBLISH_PICK_TYPE.HEART ?
              '구매 후 잔액' :
              '구매 후 개수'}
          </span>
          <span className="pick-popup-price-num">
            <Num className="pick-popup">{formatNumber(remain)}</Num>
            <span className="pick-popup-price-num--type">
              {publishMoneyType === PUBLISH_PICK_TYPE.HEART ?
                Gmoeny :
                '개'}
            </span>
          </span>
        </div>

        <Point css={PointStyle}>
          ※ 픽 구매에 대한 책임은 구매자 본인에게 있으며,
          <br/>
          본사는 보상 및 책임을 지지 않으니 신중히 구매하시기 바랍니다.
        </Point>

        <Button secondary css={BottomBtnStyle} onClick={onClickBuy} className="one-button bottom-btn">
          <CheckIco/>
          동의 후 구매하기
        </Button>

        <ModalBg onClick={onClickPickPurchasePopupCloseButton}/>
      </Modal>

      {/* 두번째 모달 (픽 구매 완료 팝업) */}
      <Modal
        transparent
        className="normal-dialog"
        visible={visibleChild}
        maskClosable={false}
        onClose={onClickPickBuyDonePopupCloseButton}
        title="픽 구매 완료"
      >
        {isBettingAvailable() ? (
          <Fragment>
            <PopupTxt className="text-center">
              구매한 픽으로 베팅이 가능합니다.
              <br/>
              내가 구매한 픽으로 이동하시겠습니까?
            </PopupTxt>
            <ButtonWrap>
              <Button
                css={PopupBtnStyle}
                className="two-button cancel dialog"
                onClick={onClickPickBuyDonePopupCancelButton}>
                취소
              </Button>
              <Button
                secondary
                css={PopupBtnStyle}
                onClick={onClickPickBuyNextStepButton}
                className="two-button dialog">
                이동
              </Button>
            </ButtonWrap>
          </Fragment>
        ) : (
          <Fragment>
            <PopupTxt className="text-center">
              픽 구매가 완료 되었습니다.
            </PopupTxt>
            <ButtonWrap>
              <Button
                secondary
                css={PopupBtnStyle}
                onClick={onClickPickBuyDonePopupCancelButton}
                className="two-button dialog">
                확인
              </Button>
            </ButtonWrap>
          </Fragment>
        )}

        <ModalBg onClick={onClickPickBuyDonePopupCloseButton}/>
      </Modal>
    </Fragment>
  )
}
export default observer(PickPurchase)
